import { createSlice } from '@reduxjs/toolkit';
import {
  signIn,
  forgotPassword,
  resetPassword,
  logoutUser,
  changePassword,
} from './authAPI';
import {
  getItem,
  saveItem,
  removeItem,
} from '../../app/common/libs/localstorage';

let isAuth = getItem('token');
let User = getItem('user');
const userCampaigns = getItem('userCampaigns');
console.log('User', User);
if (User && userCampaigns) User.Campaigns = userCampaigns;
console.log('User', User);
console.log('userCampaigns', userCampaigns);
const initialState = {
  isAuthenticated: isAuth && User ? true : false,
  user: User ? User : {},
  connectionStatus: 'Connecting',
  isLoading: false,
  error: '',
  token: '',
  success: false,
  onBoardCurrentPage: '/dashboard',
  onBoardCurrentStep: 0,
  showTourNavigation: false,
  isTourCloseModalOpen: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setConnectionStatus: (state, action) => {
      state.connectionStatus = action.payload.toLowerCase();
    },
    setSuccess: (state, action) => {
      state.success = false;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
      state.error = '';
    },
    setUserSubscription: (state, action) => {
      state.user.subscription = action.payload;
      saveItem('user', state.user);
    },
    setUserAccount: (state, action) => {
      state.user.account = { ...state.user.account, ...action.payload };
      saveItem('user', state.user);
    },
    setUserEmailVerify: (state, action) => {
      state.user.account.isEmailVerified = action.payload;
      saveItem('user', state.user);
    },
    setUserAccountVerify: (state, action) => {
      state.user.account.isAccountVerified = action.payload;
      saveItem('user', state.user);
    },
    setUserAccountBoarded: (state, action) => {
      state.user.account.isAccountOnBoarded = action.payload;
      saveItem('user', state.user);
    },
    setUserAccountError: (state, action) => {
      state.user.account.accountError = action.payload;
      saveItem('user', state.user);
    },
    setPlanAndUserData: (state, action) => {
      let planAndUserData = getItem('planData');
      planAndUserData = { ...planAndUserData, ...action.payload };
      saveItem('planData', planAndUserData);
    },
    setOnBoardCurrentStep: (state, action) => {
      state.onBoardCurrentStep = action.payload;
    },
    setShowTourNavigation: (state, action) => {
      state.showTourNavigation = action.payload;
    },
    setIsTourCloseModalOpen: (state, action) => {
      state.isTourCloseModalOpen = action.payload;
    },
    authenticateUser: (state, action) => {
      const { user, token } = action.payload;
      state.isLoading = false;
      state.error = '';
      state.user = { ...state.user, ...user };
      state.isAuthenticated = true;
      // Save login user in session storage
      saveItem('user', user);
      saveItem('token', token);
    },
    loggedInUserAuthenticated: (state, action) => {
      const user = getItem('user');
      const userCampaigns = getItem('userCampaigns');
      const token = getItem('token');
      if (user && token) {
        state.isAuthenticated = true;
        state.user = user;
        state.token = token;

        if (userCampaigns) state.user.Campaigns = userCampaigns;
      } else {
        state.isAuthenticated = false;
        state.user = '';
        state.token = '';
        state.error = '';
      }
    },
    updateUserCampaigns: (state, action) => {
      const campaigns = action.payload;
      const primary = campaigns.find((x) => x.isPrimary == true);
      state.user.PrimaryCampaign = primary;
      state.user.Campaigns = campaigns;     
      saveItem('user', state.user);
    }
  },
  extraReducers: {
    // [signIn.pending]: (state) => {
    //   state.isLoading = true;
    // },
    // [signIn.rejected]: (state, action) => {
    //   state.isLoading = false;
    //   state.error = action.payload?.Errors
    //     ? action.payload.Errors.join(',')
    //     : 'Network Error';
    // },
    // [signIn.fulfilled]: (state, action) => {
    //   const { user, token } = action.payload;
    //   state.isLoading = false;
    //   state.error = '';
    //   state.user = user;
    //   state.isAuthenticated = true;
    //   // Save login user in session storage
    //   saveItem('user', user);
    //   saveItem('token', token);
    // },
    [forgotPassword.pending]: (state) => {
      state.isLoading = true;
      state.error = '';
      state.success = false;
    },
    [forgotPassword.rejected]: (state, action) => {
      state.isLoading = false;
      state.error = action.payload?.Errors
        ? action.payload.Errors.join(',')
        : 'Network Error';
    },
    [forgotPassword.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.error = '';
      state.success = 'A verification link has been sent to your email address';
    },
    [resetPassword.pending]: (state) => {
      state.isLoading = true;
      state.error = '';
      state.success = false;
    },
    [resetPassword.rejected]: (state, action) => {
      state.isLoading = false;
      state.error = action.payload?.Errors
        ? action.payload.Errors.join(',')
        : action.payload || 'Network Error';
    },
    [resetPassword.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.error = '';
      state.success = true;
    },
    [logoutUser.pending]: (state, action) => {
      state.isLoading = true;
    },
    [logoutUser.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isAuthenticated = false;
      state.user = {};
      state.token = '';
      state.error = '';
      // Remove login user from session storage
      removeItem('user');
      removeItem('token');
      removeItem('userCampaigns');
    },
    [logoutUser.rejected]: (state, action) => {
      state.isLoading = false;
      state.isAuthenticated = false;
      state.user = {};
      state.token = '';
      state.error = '';
      // Remove login user from session storage
      removeItem('user');
      removeItem('token');
      removeItem('userCampaigns');
    },
    [changePassword.pending]: (state) => {
      state.isLoading = true;
      state.error = '';
      state.success = false;
    },
    [changePassword.rejected]: (state, action) => {
      state.isLoading = false;
      state.error = action.payload?.Errors
        ? action.payload.Errors.join(',')
        : 'Network Error';
    },
    [changePassword.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.error = '';
      state.success = true;
    },
  },
});

export const {
  setConnectionStatus,
  setSuccess,
  setError,
  loggedInUserAuthenticated,
  setLoading,
  authenticateUser,
  setUserSubscription,
  setUserAccount,
  setUserEmailVerify,
  setUserAccountVerify,
  setUserAccountError,
  setPlanAndUserData,
  setOnBoardCurrentStep,
  setShowTourNavigation,
  setIsTourCloseModalOpen,
  setUserAccountBoarded,
  updateUserCampaigns
} = authSlice.actions;

export default authSlice.reducer;
